// extracted by mini-css-extract-plugin
export default {"root":"Ki1b_","desktop":"Q8aMe","tablet":"HNZFS","mobile":"VBcAb","smallMobile":"JbMb8","icon":"LJVw_"};